<template>
  <div
    class="red-layer"
    style="display: block; transform-origin: 0px 0px; opacity: 1; transform: scale(1, 1);"
  >
    <div class="red-layer-box">
      <a class="red-layer-no" href="javascript:void(0);" @click="close"></a>
      <div class="red-layer-cai"></div>
      <div class="yhq">
        <div class="red-layer-bg">
          <img src="//i0.ulecdn.com/i/event/2019/0919/main/images/bg.png" alt />
          <p v-if="alertMain.type==3">
            恭喜你！抢到一张优惠券
            <br />下单可直接当现金使用哦
          </p>
          <p v-if="alertMain.type==2">
            恭喜你！抢到一笔鼓励金
            <br />下单可直接当现金使用哦
          </p>
          <p class="juan-p3" v-if="alertMain.type==1">{{alertMain.text}}</p>
          <p class="juan-p4" v-if="alertMain.type==0">
            <span class="p4-title">签到成功</span>
            <br />
            {{alertMain.days}}
          </p>
        </div>
        <div class="red-layer-juan juan" v-if="alertMain.type==3">
          <div class="red-layer-m">
            <p>
              ¥
              <span>{{alertMain.ticketInfo.prizeMoney}}</span>
            </p>
            <span class="sp1" v-show="alertMain.ticketInfo.fullcutAmountLimit==0">不限金额使用</span>
            <span
              class="sp1"
              v-show="alertMain.ticketInfo.fullcutAmountLimit>0"
            >满{{alertMain.ticketInfo.fullcutAmountLimit}}使用</span>
          </div>
          <div class="red-layer-text">
            <h5>
              <i>优惠券</i>
              {{alertMain.ticketInfo.collectionName}}
            </h5>
            <p style="margin:0;">{{alertMain.ticketInfo.prizeDesc}}</p>
            <p>{{alertMain.ticketInfo.expiredStartDate}} - {{alertMain.ticketInfo.expiredEndDate}} 使用</p>
          </div>
        </div>
        <div class="red-layer-juan juan3" v-if="alertMain.type==1||alertMain.type==0"></div>
        <div class="red-layer-juan juan2" v-if="alertMain.type==2">
          <p class="spq">
            ¥
            <span>{{alertMain.ticketInfo.prizeMoney}}</span>
          </p>
          <i class="spq-i">鼓励金</i>
          <p class="spq-time">{{alertMain.ticketInfo.prizeDesc}}</p>
        </div>
        <div class="red-but red-ule" v-if="alertMain.type==0">
          <div class="red-but-top clearfix">
            <a class href="javascript:void(0);" @click="close">好的，我知道了</a>
          </div>
        </div>
        <div class="red-but red-ule" v-if="alertMain.type==1">
          <div class="red-but-top clearfix">
            <a class href="javascript:void(0);" @click="close">我知道了</a>
          </div>
        </div>
        <div class="red-but red-ule" v-if="alertMain.type==3">
          <div class="red-but-top clearfix one-btn" v-show="alertMain.shareLottry==0">
            <a class href="javascript:void(0);" @click="share">分享赢红包</a>
            <a class="a2" href="javascript:void(0);" @click="close">我知道了</a>
          </div>
          <div class="red-but-top clearfix" v-show="alertMain.shareLottry==1">
            <a class href="javascript:void(0);" @click="close">好的，我知道了</a>
          </div>
        </div>
        <div class="red-but red-ule" v-if="alertMain.type==2">
          <div class="red-but-top clearfix one-btn" v-show="alertMain.shareLottry==0">
            <a class href="javascript:void(0);" @click="share">分享赢红包</a>
            <a class="a2" href @click="close">我知道了</a>
          </div>
          <div class="red-but-top clearfix" v-show="alertMain.shareLottry==1">
            <a class href="javascript:void(0);" @click="close">好的，我知道了</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>  

<script>
import Vue from "vue";
import * as URL from "../../assets/js/url.js";
export default {
  props: ["alertMain"],
  data() {
    return {
      // type: 0 //弹框显示类型0签到成功，1普通文字，2奖励金，3优惠券
      showShareMask: false
    };
  },
  mounted() {
    console.log(this.BASE.$browser().ule);
    // 将QrcodeResult方法绑定到window下面，提供给外部app原生调用
    window["shareCallback"] = result => {
      this.shareCallback(result);
    };
    if (this.BASE.$browser().ule) {
      //原来NotifyTest的js方法，需要用dsBridge注册一下，注册方法如下：
      let that = this;
      dsBridge.register("shareCallback", function(param) {
        that.shareCallback(param);
      });
    }
  },
  computed: {},
  methods: {
    close() {
      this.$emit("cjAlertState", {
        cjAlertState: false,
        shareLottry: null
      });
    },
    shareCallback(result) {
      //app分享回调方法
      //调用抽奖
      let that = this;
      this.$emit("cjAlertState", {
        cjAlertState: false,
        shareLottry: that.alertMain.lottryType
      });
    },

    share() {
      //调用分享
      var share;
      if (this.alertMain.lottryType == 0) {
        //签到分享抽奖
        share = {
          sharetitle: "天天签到，100%中奖！",
          sharecontent: "分享赢最高188元红包大奖！",
          shareimgUrl:
            "https://i0.ulecdn.com/i/event/2019/0919/main/images/shareLogo.png",
          shareLink: "https://www.ule.com/event/tmpl/ulewap.html?actId=298"
        };
      } else if (this.alertMain.lottryType == 1) {
        //下单分享抽奖
        share = {
          sharetitle: "我正在邮乐919购物下单，抽到大奖啦！",
          sharecontent: "手气好，挡都挡不住，你也来试试",
          shareimgUrl:
            "https://i0.ulecdn.com/i/event/2019/0919/main/images/shareLogo.png",
          shareLink: "https://www.ule.com/event/tmpl/ulewap.html?actId=299"
        };
      }
      //分享

      var imgUrl = share.shareimgUrl;
      //jsBridge分享参数
      var shareObj = {
        title: share.sharetitle,
        imageUrl: share.shareimgUrl,
        linkUrl: share.shareLink,
        content: share.sharecontent,
        shareType: "111",
        jsFunction: "shareCallback",
        logTitle: "919主会场"
      };
      var shareOperation = {
        type: "2",
        ios_action: JSON.stringify(shareObj),
        android_action: JSON.stringify(shareObj),
        iconTitle: "",
        imgUrl: ""
      };
      if (this.BASE.$browser().ule) {
        //调用分享
        dsBridge.call("generalAction", shareOperation);
      } else {
        this.$emit("shareMaskState", this.alertMain.lottryType);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.red-layer {
  display: none;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.red-layer .red-layer-box {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  position: relative;
  padding-top: 0.6rem;
}
.red-layer .red-layer-box:before {
  content: "";
  width: 100%;
  height: 3.45rem;
  position: absolute;
  left: 0;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/cloudf.png)
    no-repeat center;
  background-size: 100% 100%;
  top: 3.12rem;
  z-index: 5;
}
.red-layer .red-layer-box .red-layer-bg {
  width: 79.7333%;
  margin: 0 auto;
  position: relative;
}
.red-layer .red-layer-box .red-layer-bg img {
  display: block;
  width: 100%;
}
.red-layer .red-layer-box .red-layer-bg p {
  position: absolute;
  text-align: center;
  font-size: 0.3rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(252, 255, 0, 1);
  line-height: 0.48rem;
  width: 100%;
  top: 0.54rem;
  left: 0;
}
.red-layer .red-layer-box .red-layer-bg .juan-p3 {
  top: 34%;
  font-size: 0.36rem;
}
.red-layer .red-layer-box .red-layer-bg .juan-p4 {
  top: 23%;
  line-height: 1.5;
  .p4-title {
    font-size: 0.52rem;
  }
}

.red-layer-box .red-layer-cai {
  width: 90.667%;
  height: 3.24rem;
  display: block;
  margin: 0 auto;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/head.png)
    no-repeat center;
  background-size: 100% 100%;
}
.red-layer-box .red-layer-juan,
.red-layer-box .red-layer-jli,
.red-layer-box .red-layer-rom {
  width: 97.6666%;
  height: 5.34rem;
  position: absolute;
  left: 50%;
  bottom: -1.87rem;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 3;
}
.red-layer-box .juan {
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/bg-ticket.png)
    no-repeat center;
  background-size: 100% 100%;
}
.red-layer-box .juan2 {
  background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/bg-bounty.png")
    no-repeat center;
  background-size: 100% 100%;
  .spq {
    text-align: center;
    color: #c94c00;
    font-size: 0.24rem;
    margin-top: 0.6rem;
    span {
      font-size: 0.7rem;
    }
  }
  .spq-i {
    font-size: 0.24rem;
    position: absolute;
    top: 20%;
    right: 25%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 0.86rem;
    height: 0.34rem;
    line-height: 0.34rem;
    background: #f3281e;
    border-radius: 0.13rem;
    color: #fff;
    text-align: center;
  }
  .spq-time {
    color: #c94c00;
    text-align: center;
  }
}
.red-layer-box .juan3 {
  background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/bg-none.png")
    no-repeat center;
  background-size: 100% 100%;
}
.red-layer-box .red-layer-juan .red-layer-m {
  position: absolute;
  top: 0.32rem;
  left: 16.9%;
  text-align: center;
  color: #f3281e;
  font-size: 0.24rem;
  height: 1.6rem;
  width: 25%;
  padding-top: 0.12rem;
}
.red-layer-box .red-layer-juan .red-layer-m p {
  font-size: 0.3rem;
  margin-bottom: 0.02rem;
}
.red-layer-box .red-layer-juan .red-layer-m p span {
  font-size: 0.7rem;
}
.red-layer-box .red-layer-juan .red-layer-m .sp1 {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.red-layer-box .red-layer-juan .red-layer-text {
  position: absolute;
  top: 0.32rem;
  right: 16.6%;
  color: #fff;
  font-size: 0.24rem;
  height: 1.6rem;
  width: 41%;
  padding-top: 0.22rem;
  padding-left: 0.2rem;
  box-sizing: border-box;
}
.red-layer-juan .red-layer-text h5 {
  max-height: 0.8rem;
  line-height: 0.4rem;
  font-size: 0.26rem;
  color: #f3281e;
  position: relative;
  padding-left: 1rem;
  // overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-bottom: 0.1rem;
}
.red-layer-juan .red-layer-text h5 i {
  font-size: 0.24rem;
  position: absolute;
  top: 50%;
  left: 0;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 0.86rem;
  height: 0.34rem;
  line-height: 0.34rem;
  background: #f3281e;
  border-radius: 0.13rem;
  color: #fff;
  text-align: center;
}
.red-layer-juan .red-layer-text p {
  font-size: 0.24rem;
  color: #999999;
  // margin-top: 0.1rem;
  -webkit-transform: scale(0.8333) translateX(-9%);
  -moz-transform: scale(0.8333) translateX(-9%);
  -ms-transform: scale(0.8333) translateX(-9%);
  -o-transform: scale(0.8333) translateX(-9%);
  transform: scale(0.8333) translateX(-9%);
}
.red-layer-box .red-layer-no {
  position: absolute;
  width: 0.72rem;
  height: 0.72rem;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/c1.png)
    no-repeat center;
  background-size: 100% 100%;
  z-index: 4;
  top: 0.61rem;
  right: 0.61rem;
}
/* 奖励金 */
.red-layer-box .red-layer-jli {
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/bg-bounty.png)
    no-repeat center;
  background-size: 100% 100%;
}
.red-layer-jli .red-layer-m {
  position: absolute;
  top: 0.32rem;
  left: 15.7%;
  text-align: center;
  color: #fff;
  font-size: 0.24rem;
  height: 1.6rem;
  width: 66.7%;
  padding-top: 0.12rem;
  box-sizing: border-box;
}
.red-layer-jli .red-layer-m h5 {
  font-size: 0.3rem;
  color: #c94c00;
}
.red-layer-jli .red-layer-m h5 span {
  font-size: 0.7rem;
  font-weight: 500;
}
.red-layer-jli .red-layer-m p {
  font-size: 0.26rem;
  color: #c94c00;
  margin-top: 0.1rem;
}
.red-layer-jli .red-layer-m i {
  font-size: 0.24rem;
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.86rem;
  height: 0.34rem;
  line-height: 0.34rem;
  background: rgba(255, 80, 77, 1);
  border-radius: 0.13rem;
  color: #fff;
  text-align: center;
}
/* 没有中奖 */
.red-layer-box .red-layer-rom {
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/bg-none.png)
    no-repeat center;
  background-size: 100% 100%;
}
.red-layer-bg .red-no-text {
  color: #fcff00;
  font-size: 0.3rem;
  line-height: 0.48rem;
  padding-top: 0.3rem;
}
.red-layer-bg .red-no-text span {
  font-size: 0.56rem;
  font-weight: bold;
  line-height: 1.2rem;
}
.red-but {
  width: 80.8666%;
  position: absolute;
  left: 50%;
  bottom: -1.06rem;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 4;
}
.red-but .red-but-top {
  width: 100%;
}
.red-but .red-but-top a {
  height: 1.1rem;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/btn-try.png)
    no-repeat center;
  background-size: 100% 100%;
  line-height: 1rem;
  text-align: center;
  width: 49.6%;
  font-size: 0.28rem;
  color: #fff;
  margin: 0 auto;
}
.red-but .one-btn {
  width: 100%;
  overflow: hidden;
}
.red-but .one-btn a {
  float: left;
  width: 48% !important;
}
.red-but .one-btn .a2 {
  float: right !important;
  margin-top: 0 !important;
}
.red-but .red-but-zc {
  font-size: 0.24rem;
  color: #4900a3;
  text-align: center;
  width: 70%;
  margin: 0 auto;
  margin-top: -0.06rem;
}
.red-but.red-ule .red-but-zc {
  margin-top: -0.16rem;
}
.red-but.red-ule {
  bottom: -0.92rem;
}
.red-but.red-ule .red-but-top a {
  width: 87%;
  display: block;
  height: 1.1rem;
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/btn-share.png)
    no-repeat center;
  background-size: 100% 100%;
  text-align: center;
  font-size: 0.28rem;
  margin: 0 auto;
  color: #fff;
  line-height: 1rem;
}
.red-but.red-ule .red-but-top .a2 {
  margin-top: -0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/cjAlert.vue